module.exports = __webpack_public_path__ + "img/aumentar.4890ae42.svg";